// styles
import { chartDashboardBoxStyle, chartDashboardType04Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledChartCard = styled.div`
  // ${chartDashboardBoxStyle}
  // ${chartDashboardType04Style}
`;
